import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import connectedFeatureAvailabilityWrapper from "../../common/withFeatureAvailability";
import TLDRDownloadOptionsWrapper from "./TLDRDownloadOptionsWrapper";
import {
  Text,
  Divider,
  HStack,
  Icon,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { getStoryStats } from "../../../_utils/common";
import { FaChevronLeft } from "react-icons/fa";

class TLDRDownloadOptionsDropDown extends Component {
  constructor(props) {
    super(props);
    this.initState = {
      isDownloading: false,
      downloadingArtBoardIndex: 0,
      selectedArtBoards: [],
    };
    this.state = this.initState;
  }

  onDownloading = (state) => {
    this.setState({
      isDownloading: state,
    });
    this.props.onDownloading && this.props.onDownloading(state);
  };

  onArtBoardsSelectionChange = (selectedArtBoards) => {
    this.setState({
      selectedArtBoards,
    });
  };

  render() {
    const { t, onClose } = this.props;
    const { story, pagestore } = this.props;
    const { pageIds, pages } = pagestore;

    const [isStoryHeightAndWidthConsistent, storyDuration] = getStoryStats(
      Object.values(pages)
    );

    return (
      <>
        <HStack alignItems="center" my="1">
          <Icon
            as={FaChevronLeft}
            ml="0"
            onClick={onClose}
            _hover={{
              color: "brand.primary",
              cursor: "pointer"
            }}
          />
          <Text
            fontSize="sm"
            fontWeight="bold"
          >
            {t("download_project")}
          </Text>
        </HStack>

        <Divider my="2" />

        <TLDRDownloadOptionsWrapper
          story={story}
          inline
          storyDuration={storyDuration}
          isStoryHeightAndWidthConsistent={isStoryHeightAndWidthConsistent}
          onDownloading={this.onDownloading}
          onArtBoardsSelectionChange={this.onArtBoardsSelectionChange}
          pageIds={pageIds}
        />
      </>
    );
  }

  onArtBoardsSelectionChange = (selectedArtBoards) => {
    this.setState({
      ...this.state,
      selectedArtBoards,
    });
  };
}

TLDRDownloadOptionsDropDown.propTypes = {
  pagestore: PropTypes.object.isRequired,
  story: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  story: state.story,
  pagestore: state.pagestore,
});

export default connectedFeatureAvailabilityWrapper(
  withTranslation(["navbar", "billing"])(
    connect(mapStateToProps)(TLDRDownloadOptionsDropDown)
  )
);
